import http from '../utils/http'
//测试
export function getdata(params){
    return http.post(`/api/data`,params)
}
//部门列表
export function departmentmock(params){
    return http.post(`/api/departmentList`,params)
}


// WEBPACK FOOTER //
// ./src/api/apimock.js